import $$ from 'cmn-utils'

const baseUrl = "/api/sys/product/version/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },

}